import React from 'preact/compat';
import { Field } from 'formik';
import FormLabel from '../label';
import FormError from '../error';
import FormHelp from '../help';
import { useSelfServiceFormContext } from './context';
import { ProductMenuOptions } from './common';

export default function ProductEnquiryFields() {
    const {
        products,
        links: { faqs },
        classNames: {
            button: classNames,
        },
    } = useSelfServiceFormContext();

    return (
        <div className='form__grid'>
            <div className='form__grid-item  form__grid-item--wide  form__field'>
                <FormLabel htmlFor='enquiryProduct' required={true}>Choose a product</FormLabel>
                <FormHelp> If the product you are looking for is not listed, it means we no longer produce it and it has been discontinued; we politely request that you do not choose another product to ask about a discontinued one, thank you.</FormHelp>
                <Field as='select' name='productEnquiry.product' id='enquiryProduct' className='input  input--select'>
                    <option />
                    <ProductMenuOptions options={products} />
                </Field>
                <FormError name='productEnquiry.product' />
            </div>
            <div className='form__grid-item  form__grid-item--wide  form__field'>
                <FormLabel htmlFor='productEnquiry' required={true}>Tell us about your enquiry</FormLabel>
                <FormHelp>For stockists and where to buy please refer to the <a href={faqs}>frequently asked questions</a>.</FormHelp>
                <Field as='textarea' name='productEnquiry.enquiry' id='productEnquiry' className='input  input--textarea' />
                <FormError name='productEnquiry.enquiry' />
            </div>
            <div className='form__grid-item  form__grid-item--wide'>
                <a href='#contact-fields' className={classNames.submit}>
                    Continue
                </a>
            </div>
        </div>
    );
}
